import clsx from 'clsx';
import styles from './ClickableButton.module.css';

function ClickableButton({ label, onClick, className = '' }) {
  return (
    <button
      className={clsx(styles.ClickableButton, className)}
      onClick={onClick && onClick}
    >
      {label}
    </button>
  );
}

export default ClickableButton;
